import * as React from 'react';

import { toMoney } from '@rematter/common/money';
import { CurrencyCode } from '@rematter/frontend-lib-api-client';
import { NumberField, cn } from '@rematter/ui-web';

import { FinanceLineItemData, FinanceLineItemErrors } from '../types';

interface QuantityFieldCellProps {
  lineItem: FinanceLineItemData;
  currencyCode: CurrencyCode;
  onUpdate: (id: string, updates: Partial<FinanceLineItemData>) => void;
  disabled?: boolean;
  errors?: FinanceLineItemErrors;
}

export const QuantityFieldCell: React.FC<QuantityFieldCellProps> = ({
  lineItem,
  currencyCode,
  onUpdate,
  disabled = false,
  errors,
}) => {
  const handleChange = React.useCallback(
    (value: number | undefined) => {
      const quantity = value ?? null;
      const unitPriceAmount = lineItem.unitPrice?.amount ?? 0;
      const totalAmount = quantity != null ? quantity * unitPriceAmount : 0;

      onUpdate(lineItem.id, {
        quantity,
        totalPrice: toMoney({
          amount: totalAmount,
          currencyCode,
        }),
      });
    },
    [lineItem.id, lineItem.unitPrice?.amount, currencyCode, onUpdate],
  );

  return (
    <NumberField
      value={lineItem.quantity ?? undefined}
      onChange={handleChange}
      isDisabled={disabled}
      isInvalid={!!errors?.quantity}
      errorMessage={errors?.quantity}
      minValue={0}
      showSteppers={false}
      className={cn('@QuantityFieldCell')}
    />
  );
};
